import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { KeyRound, LogIn, AlertCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { authAPI, getErrorMessage } from '../services/api';

export default function Login({ onLoginSuccess }) {
  const [apiKey, setApiKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [shouldRedirect, setShouldRedirect] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authAPI.login(apiKey.trim());

      localStorage.setItem('auth_token', result.access_token);
      localStorage.setItem('user_role', result.role || 'admin');

      toast.success('Connected to backend');
      onLoginSuccess?.();
      setShouldRedirect(true);
    } catch (err) {
      const message = getErrorMessage(err);
      setError(message);
      toast.error('Login failed');
    } finally {
      setLoading(false);
    }
  };

  if (shouldRedirect) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl">
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6 text-white">
          <h1 className="text-3xl font-bold">School-Payment-Bot</h1>
          <p className="text-blue-100 mt-1">Admin Console</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex gap-3 text-red-700">
              <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
              <span className="text-sm">{error}</span>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Admin API Key
            </label>
            <div className="relative">
              <KeyRound className="absolute left-3 top-3.5 w-5 h-5 text-gray-400" />
              <input
                type="password"
                name="school-payment-admin-key"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter admin API key"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium py-2 rounded-lg flex items-center justify-center gap-2 disabled:opacity-50 transition-all"
          >
            <LogIn className="w-5 h-5" />
            {loading ? 'Connecting...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
